import React from 'react';

const PagesConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      // Reachable by anybody, signed in or not: it is where a denial redirects to,
      // and gating the page that explains a gate would loop.
      path: '/pages/errors/error-403',
      auth: null,
      settings: {
        layout: {
          config: {
            /*
              No navigation on this page. It is the one screen whose whole message is
              "this is not yours to open", and drawing the menu of sections down the
              left — several of which are not theirs either — argues with that and
              invites a second click on a second refusal. The page's own link back to
              the home page is the way out.

              Route-level, so the other two error pages keep the layout they have:
              404 and 500 are about a page that broke, not about access.
            */
            navbar: { display: false }
          }
        }
      },
      component: React.lazy(() => import('./errors/403/Error403Page'))
    },
    {
      path: '/pages/errors/error-404',
      component: React.lazy(() => import('./errors/404/Error404Page'))
    },
    {
      path: '/pages/errors/error-500',
      component: React.lazy(() => import('./errors/500/Error500Page'))
    }
  ]
};

export default PagesConfig;
